<template>
  <crud-form
    v-model="payload"
    :request-class="requestClass"
    page-title="Adicionar marca"
    :total-group="3"
    navigate-back-route="marca.list"
    navigate-page-after-save="marca.list"
    :override-create-payload="overrideCreatePayload"
    :override-edit-payload="overrideEditPayload"
    :override-set-entity-data="overrideSetEntityData"
  >
    <template slot="group-1">
      <form-group
        id="form"
        title="Dados da marca"
      >
        <v-row>
          <v-col cols="6">
            <input-text
              id="input:nomMarca"
              v-model="payload.nomMarca"
              label="Nome da marca"
              required
            />
          </v-col>
          <v-col
            v-if="payload.id"
            cols="6"
          >
            <input-text
              id="input:id"
              v-model="payload.id"
              label="Código"
              disabled
            />
          </v-col>
        </v-row>
      </form-group>
    </template>
    <template
      v-if="getMarcaId"
      slot="group-2"
    >
      <v-divider />
    </template>
    <template
      v-if="getMarcaId"
      slot="group-3"
    >
      <v-tabs v-model="tabs">
        <v-tab>
          Regionais marca
        </v-tab>
        <v-tab>
          Integrador marca
        </v-tab>
        <v-tabs-items v-model="tabs">
          <v-tab-item>
            <v-col
              cols="12"
            >
              <v-row>
                <v-col>
                  <div class="d-flex align-center justify-end pa-8">
                    <h1 class="h1Header secondary300">
                      Regionais
                    </h1>
                    <v-spacer />
                  </div>
                </v-col>
              </v-row>
              <regional-crud-list :marca-id="this.$route.params.id" />
            </v-col>
          </v-tab-item>
          <v-tab-item>
            <v-col
              cols="12"
            >
              <v-row>
                <v-col>
                  <div class="d-flex align-center justify-end pa-8">
                    <h1 class="h1Header secondary300">
                      Integrador
                    </h1>
                    <v-spacer />
                  </div>
                </v-col>
              </v-row>
              <marca-integrador-crud-list />
            </v-col>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </template>
  </crud-form>
</template>

<script>
import CrudForm from '@/app/arch/components/crud/CrudForm.vue';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import MarcaRequest from 'Modules/contacard/produto/marca/MarcaRequest';
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import NotificationMixin from '@/app/arch/mixins/NotificationMixin';
import RegionalCrudList from 'Modules/contacard/produto/marca/regional/RegionalCrudList.vue';
import MarcaIntegradorCrudList from 'Modules/contacard/produto/integrador/IntegradorCrudList.vue';

export default {
  name: 'MarcaForm',
  components: {
    CrudForm, FormGroup, RegionalCrudList, MarcaIntegradorCrudList,
  },
  mixins: [RulesMixin, NotificationMixin],
  data: () => ({
    requestClass: MarcaRequest,
    payload: {
      nomMarca: '',
      id: '',
    },
    isActive: null,
    tabs: null,
  }),
  computed: {
    getMarcaId() {
      return this.$route.params.id;
    },
  },
  watch: {
    'payload.id': {
      handler(value) {
        this.isActive = value;
      },
    },
  },
  methods: {
    overrideSetEntityData(data) {
      return { ...data };
    },
    overrideCreatePayload() {
      return { ...this.payload };
    },
    overrideEditPayload() {
      return { ...this.payload };
    },
  },
};
</script>

<style scoped>
#form {
  padding-top: 2rem;
}
</style>
